import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Result } from 'antd';
import { getMenuList } from '@/utils/menu'

let Interval = null
export default function NotFound() {
  const navigate = useNavigate()
  const [count, setCount] = useState(3)
  const [menuList, setMenulist] = useState([])

  useEffect(() => {
    let timer = 3
    setCount(timer)
    let menulist = getMenuList() || []
    setMenulist(menulist)
    Interval = setInterval(() => {
      timer--
      setCount(timer)
      if (timer <= 0) {
        clearInterval(Interval)
        navigate(menulist[0]?.children[0]?.key || '/')
        return
      }
    }, 1000)
  }, [])
  return (
    <div>
      <Result status="404" title="404" subTitle={'页面不见了, ' + count + ' 秒后返回首页'} extra={
        <Button type="primary" href={'/#' + menuList[0]?.children[0]?.key || '/'}>Back Home</Button>
      } />
    </div>
  )
}
